import { render } from "./SobreMim.vue?vue&type=template&id=1dc58764&scoped=true"
import script from "./SobreMim.vue?vue&type=script&lang=js"
export * from "./SobreMim.vue?vue&type=script&lang=js"

import "./SobreMim.css?vue&type=style&index=0&id=1dc58764&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc58764"]])

export default __exports__